import {
  GET_NOTICATIONS_STARTED,
  GET_NOTICATIONS_SUCCESS,
  GET_NOTIFICATION_PREFERENCES_SUCCESS,
  PUSH_NEW_NOTIFICATION
} from '../actions/actionTypes'

const defaultState = {
  isGettingNotifications: false,
  notificationList: {},
  notificationPreferences: null,
  gotNotificationsList: false
}

const defaultPreferences = [
  {
    kind: 'NegativeReview',
    subsidiaries: []
  },
  {
    kind: 'WaitingClientChatExists',
    subsidiaries: []
  }
]

export default function notifications(state = defaultState, action) {
  switch (action.type) {
    case GET_NOTIFICATION_PREFERENCES_SUCCESS: {
      return {
        ...state,
        notificationPreferences: action.payload || defaultPreferences
      }
    }

    case PUSH_NEW_NOTIFICATION: {
      const kind =
        action.payload.kind === 'ServiceChatMessageReceived' ? 'Service' : 'Sales'

      const subsidiaryNotifications = state.notificationList[action.payload.subsidiaryId]

      return {
        ...state,
        notificationList: {
          ...state.notificationList,
          [action.payload.subsidiaryId]: {
            ...(subsidiaryNotifications ? subsidiaryNotifications : {}),
            [kind]: {
              count:
                subsidiaryNotifications && subsidiaryNotifications[kind]
                  ? subsidiaryNotifications[kind].count
                  : 1
            }
          }
        }
      }
    }

    case GET_NOTICATIONS_STARTED:
      return {
        ...state,
        isGettingNotifications: true
      }

    case GET_NOTICATIONS_SUCCESS:
      return {
        ...state,
        gotNotificationsList: true,
        isGettingNotifications: false,
        notificationList: action.payload.reduce((prev, curr) => {
          return {
            ...prev,
            [curr.subsidiaryId]: {
              ...(prev[curr.subsidiaryId] ? prev[curr.subsidiaryId] : {}),
              [curr.kind]: {
                count: curr.count
              }
            }
          }
        }, {})
      }

    default:
      return state
  }
}
